import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín Sosa',
  role: 'Rosario, Santa Fe',
  text: 'Me pasaba que tenía las herramientas clásicas pero no sabía cómo ajustarlas a un atleta en silla de ruedas sin sonar desubicado. Este kit me dio un orden clínico espectacular. Entro a sesión mucho más seguro.'
}, {
  name: 'Carolina Méndez',
  role: 'Córdoba',
  text: 'El módulo de discapacidad adquirida vale oro. Estaba acompañando a un jugador que tuvo un accidente y no sabía cómo estructurar el duelo deportivo. Las plantillas me salvaron.'
}, {
  name: 'Javier Ramírez',
  role: 'CABA',
  text: 'Directo al grano. Cero frases motivacionales vacías. Es un sistema de trabajo real. Lo apliqué la misma semana que lo compré con un nadador paralímpico y la diferencia en la evaluación inicial fue abismal.'
}, {
  name: 'Agustina López',
  role: 'La Plata, Buenos Aires',
  text: 'Siempre me costó el trabajo con el entorno y los entrenadores en deporte adaptado porque a veces sobreprotegen al deportista. Los guiones de comunicación me ayudaron a poner límites claros.'
}, {
  name: 'Diego Fernández',
  role: 'Mendoza',
  text: 'Excelente inversión. Las técnicas de regulación emocional adaptadas son súper prácticas. Ya no improviso, tengo un plan claro para cada etapa del proceso.'
}];
export function Testimonials() {
  return <section className="py-20 bg-white" data-id="element-190">
      <div className="container px-4 mx-auto max-w-6xl" data-id="element-191">
        <div className="text-center mb-12" data-id="element-192">
          <h2 className="text-3xl font-black text-[#0c3b42] uppercase tracking-tight" data-id="element-193">
            LO QUE DICEN OTROS PROFESIONALES
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-194">
          {testimonials.map((test, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-slate-50 p-6 rounded-2xl border border-slate-200 shadow-sm" data-id="element-195">
              <div className="flex gap-1 mb-4" data-id="element-196">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#f59e0b] text-[#f59e0b]" data-id="element-197" />)}
              </div>
              <p className="text-slate-700 italic mb-6 leading-relaxed" data-id="element-198">
                "{test.text}"
              </p>
              <div data-id="element-199">
                <div className="font-bold text-[#0c3b42]" data-id="element-200">{test.name}</div>
                <div className="text-sm text-slate-500" data-id="element-201">{test.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}